module.exports = __webpack_public_path__ + "static/media/footor.fb7ac738.png";